import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { rightsizingRecommendationsDismissedDataSelector } from "./rightsizingRecommendationsDismissedDataSelector";

export const rightsizingRecommendationsDismissedDataTotalLengthSelector =
  createDraftSafeSelector(
    [rightsizingRecommendationsDismissedDataSelector],
    (data) => data?.length ?? 0,
  );
